<template>
  <!-- <q-page class="q-pa-md"> -->
    <q-table
      flat
      bordered
      :rows="computedBulkTransactionData"
      :columns="columns"
      :pagination="pagination"
      separator="cell"
      binary-state-sort
      :filter="filterSymbol"
      :filter-method="(rows) => filterSymbolData(rows, filterSymbol)"
      :class="
        $q.dark.mode
          ? 'table-sticky-header-column-dark'
          : 'table-sticky-header-column'
      "
    >
      <template v-slot:body-cell-symbol="props">
        <q-td
          :props="props"
          :class="
            props.row.cng_value < 0
              ? 'bg-red-5 text-white'
              : props.row.cng_value > 0
              ? 'bg-green-5 text-white'
              : 'bg-blue-5 text-white'
          "
        >
          <div class="col">
            {{ props.value }}
            <q-tooltip>{{
              allStocks.find((stock) => stock.symbol == props.value)?.name
            }}</q-tooltip>
          </div>
        </q-td>
      </template>

      <template v-slot:body-cell="props">
        <q-td
          :props="props"
          :class="
            props.row.cng_value < 0
              ? 'bg-red-5 text-white'
              : props.row.cng_value > 0
              ? 'bg-green-5 text-white'
              : 'bg-blue-5 text-white'
          "
        >
          {{ props.value }}
        </q-td>
      </template>
    </q-table>
  <!-- </q-page> -->
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import useUtils from "src/use/utils";
import useData from "src/use/data";
import { useStore } from "vuex";

import moment from "moment";
import { useQuasar } from "quasar";
const props = defineProps({
  symbol: {
    type: String,
  },
});
const store = useStore();
const $q = useQuasar();
const { amountConversion, filterSymbolData } = useUtils();

const filterSymbol = ref("");

const { BulkTransactionWithMarketBuySell, CircuitSetup } = useData();

const allStocks = ref([]);
const bulkTransactionData = ref([]);
const circuitSetupData = ref([]);

async function loadLiveData() {
  $q.loading.show({});
  try {
    const resBulkTransactionData = await BulkTransactionWithMarketBuySell();
    const resCircuitSetupData = await CircuitSetup();

    bulkTransactionData.value = resBulkTransactionData.data;
    circuitSetupData.value = resCircuitSetupData.data;
  } catch (error) {
    console.error("Error loading live data:", error);
  } finally {
    $q.loading.hide();
  }
}

const computedBulkTransactionData = computed(() => {
  return bulkTransactionData.value.filter((i) => i.symbol == props.symbol);
});

onMounted(async () => {
  await loadLiveData();

  allStocks.value = store.state.core.allStocks || [];
  if (!allStocks.value.length) {
    await store.dispatch("core/getAllStocks");
    allStocks.value = store.state.core.allStocks;
  }
});

const columns = [
  {
    name: "date",
    label: "Date",
    field: "date",
    format: (val, row) => {
      return convertDate(val);
    },
    sortable: true,
    align: "left",
  },
  {
    name: "symbol",
    label: "Symbol",
    field: "symbol",
    sortable: true,
    align: "center",
  },
  {
    name: "status",
    label: "Status",
    field: "status",
    format: (val, row) => {
      return row.cng_value < 0 ? "SELL" : row.cng_value > 0 ? "BUY" : "-";
    },
    sortable: true,
    align: "center",
  },
  // {
  //   name: "transaction",
  //   label: "From Txn",
  //   field: "transaction",
  //   format: (val, row) => {
  //     return "... " + String(val).slice(-8);
  //   },
  //   sortable: true,
  //   align: "center",
  // },
  // {
  //   name: "to_transaction",
  //   label: "To Txn",
  //   field: "to_transaction",
  //   format: (val, row) => {
  //     return "... " + String(val).slice(-8);
  //   },
  //   sortable: true,
  //   align: "center",
  // },
  {
    name: "cnt",
    label: "No. of Tnx",
    field: "cnt",
    sortable: true,
    align: "center",
  },

  {
    name: "cumm_quantity",
    label: "Cumm Qnt",
    field: "cumm_quantity",
    sortable: true,
    align: "center",
  },
  {
    name: "rate",
    label: "Rate",
    field: "rate",
    sortable: true,
    format: (val, row) => {
      return val?.toFixed(2);
    },
    align: "center",
  },
  {
    name: "amt",
    label: "Amt",
    field: "amt",
    format: (val, row) => {
      return amountConversion(row.cumm_quantity * row.rate);
    },
    sortable: true,
    align: "center",
  },
  // {
  //   name: "f_rate",
  //   label: "From Rate",
  //   field: "f_rate",
  //   format: (val, row) => {
  //     return val?.toFixed(2);
  //   },
  //   sortable: true,
  //   align: "center",
  // },
  // {
  //   name: "t_rate",
  //   label: "To Rate",
  //   field: "t_rate",
  //   format: (val, row) => {
  //     return val?.toFixed(2);
  //   },
  //   sortable: true,
  //   align: "center",
  // },
  // {
  //   name: "cng_value",
  //   label: "CH. Value",
  //   field: "cng_value",
  //   format: (val, row) => {
  //     return val?.toFixed(2);
  //   },
  //   sortable: true,
  //   align: "center",
  // },
];

const pagination = {
  sortBy: "date",
  rowsPerPage: 0,
  descending: true,
};

const convertDate = (date) => moment(date).format("YYYY-MM-DD, hh:mm A");
</script>
